import { SettingsSidebarGroup } from "./SettingsSidebar";

function getAvailablePaths(isRoot: boolean): string[] {
  return getSidebarGroups(isRoot)
    .flatMap((group) => group.items)
    .filter((item) => "path" in item)
    .map((item) => (item as { path: string }).path);
}

export function isPathAvailable(path: string | undefined, isRoot: boolean): boolean {
  if (!path) return false;

  const pathSegment = path.includes("/") ? path.split("/").pop() : path;

  return getAvailablePaths(isRoot).includes(pathSegment as string);
}

export function getSidebarGroups(isRoot: boolean): SettingsSidebarGroup[] {
  if (isRoot) {
    return [
      {
        items: [
          { label: "Users", path: "users", icon: "User" },
          { label: "Businesses", path: "businesses", icon: "Businesses" },
          { label: "Schedules", path: "email_schedules", icon: "Schedules" },
          { label: "Budgets (Target)", path: "budget", icon: "Budget" },
        ],
      },
    ];
  }

  // Non-root users have no settings pages; the sidebar still offers Back to Home and Logout.
  return [];
}
